import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CreatePostPage } from "@/features/community/components/create-post-page";

interface CommunityNewSearch {
  product?: string;
}

// Crear publicación. `?product=<id>` pre-etiqueta un set (deep-link desde la
// galería / detalle de producto).
function CreatePostRoutePage() {
  const search = communityNewRoute.useSearch();
  return <CreatePostPage initialProductId={search().product} />;
}

export const communityNewRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/community/new",
  validateSearch: (search: Record<string, unknown>): CommunityNewSearch => ({
    product: typeof search.product === "string" ? search.product : undefined,
  }),
  component: CreatePostRoutePage,
});
